import React, { useContext } from 'react';

import { PagePropsContext } from '../App';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CategoryCard from '../components/CategoryCard';
import { getCategoryImage, getRootCategories } from '../utils/functions';

const PageCategory = () => {
  const { categories, selectedCategory, setSelectedCategory } = useContext(PagePropsContext);

  return <div className='page page--category'>
    <Header
      title={selectedCategory.name}
      showBreadcrumb={true}
      showSearch={true}
      onBack={() => setSelectedCategory(null)}
    />
    <div className='page__content'>
      <CategoryCard
        category={selectedCategory}
        icon={getCategoryImage(getRootCategories(categories).indexOf(selectedCategory))}
        isExpanded={true}
      />
    </div>
    <Footer />
  </div>;
}

export default PageCategory;